import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Button from "@mui/material/Button";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { type FC } from "react";
import css from "src/styles/dialog.module.css";
import theme from "src/styles/theme";
import type { CreateCaseResult } from "../api/casesApi";
import { formatMaybeCurrency } from "../mappers/utils";
import { CaseType } from "../../WorkPackets/Cases/case-types";

interface CaseTypeConfig {
  title: string;
  urlBreadcrumbs: string;
}

const caseTypeConfigMap: Record<CaseType, CaseTypeConfig> = {
  [CaseType.SHORTAGE_ESCALATION]: {
    title: "Shortage escalation",
    urlBreadcrumbs: "shortages/escalations",
  },
  [CaseType.SHORTAGE_SETTLEMENT]: {
    title: "Shortage settlement",
    urlBreadcrumbs: "shortages/settlements",
  },
  [CaseType.CHARGEBACK_ESCALATION]: {
    title: "Chargeback escalation",
    urlBreadcrumbs: "chargebacks/escalations",
  },
};

export interface CreateCaseSuccessPopupProps {
  details: CreateCaseResult;
  caseType: CaseType;
  onClose: () => void;
}

export const CreateCaseSuccessPopup: FC<CreateCaseSuccessPopupProps> = ({
  details: { caseId, workPacketCount, totalDisputeAmount },
  caseType,
  onClose,
}) => {
  const { title, urlBreadcrumbs } = caseTypeConfigMap[caseType];
  return (
    <ThemeProvider theme={theme}>
      <div className={css.dialog} style={{ maxWidth: "calc(100dvw - 2rem)", width: "32rem" }}>
        <div className={css.content}>
          <p className={css.title}>{title} case created successfully</p>
          <p>
            Work packet count:{" "}
            <b>
              {workPacketCount} {workPacketCount === 1 ? <>work packet</> : <>work packets</>}
            </b>
          </p>
          {Number.isFinite(totalDisputeAmount) && totalDisputeAmount !== 0 && (
            <p>
              Total dispute amount: <b>{formatMaybeCurrency(totalDisputeAmount)}</b>
            </p>
          )}
        </div>
        <div className={css.buttonGroup}>
          <Button onClick={onClose} className={css.button} variant="outlined">
            Dismiss
          </Button>
          <a
            href={`/user-dashboard/work-packets/${urlBreadcrumbs}/${caseId}`}
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <Button className={css.button} variant="contained" color="primary" endIcon={<OpenInNewIcon />}>
              Open/edit case details in new tab
            </Button>
          </a>
        </div>
      </div>
    </ThemeProvider>
  );
};
